import * as React from "react";

const LowStock: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13">
            <g fill="none" fill-rule="evenodd">
                <g fill="#004DA6" fill-rule="nonzero">
                    <g>
                        <path
                            d="M15.89 11.502L8.615.325C8.481.123 8.25 0 8 0s-.481.123-.615.325L.111 11.502c-.142.218-.148.493-.016.717.132.223.382.358.649.352h14.549c.26-.006.498-.147.62-.368.124-.22.115-.488-.023-.7zm-7.145-1.026H7.291V9.079h1.454v1.397zm0-2.795H7.291V4.188h1.454v3.493z"
                            transform="translate(-735 -959) translate(735 959)"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(LowStock);
